export default __webpack_public_path__ + "static/media/C3.c7597f23.png";